import split from 'lodash/split'


// hop in to UI directives. Example expandTopSubstanceFact_IDE;
export const UI_DIRECTIVES = {
  EXPAND_TOP_SUBSTANCE_FACT: 'expandTopSubstanceFact',
  DIRECTIVES_SEPARATOR: ';',
  DIRECTIVE_VALUE_SEPARATOR: '_',
};

export const EXPAND_TOP_SUBSTANCE_FACT_MAPPING = {
  ID: ['ID', 'IDE'],
  BIO_MED_ALL: ['PED', 'DAT'],
  PRODD: 'rcssupplier',
};

export function getUIDirectiveValue(parameter, directiveName) {
  if(!parameter || !directiveName) {
    return null;
  }
  const directive = split(parameter, UI_DIRECTIVES.DIRECTIVES_SEPARATOR).find(value => value.indexOf(directiveName) >= 0);
  return directive && split(directive, UI_DIRECTIVES.DIRECTIVE_VALUE_SEPARATOR)[1] || null;
}

export function getExpandTopSubstanceFactMappingValue(directiveValue) {
  if(!directiveValue) {
    return null;
  }
  return Object.keys(EXPAND_TOP_SUBSTANCE_FACT_MAPPING).find(key => EXPAND_TOP_SUBSTANCE_FACT_MAPPING[key].indexOf(directiveValue) >= 0);
}